import React, { useEffect, useRef, useState } from "react";
import Search from "../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../assets/svg/svg27.svg";
import svg12 from "../../assets/svg/svg12.svg";
import svg13 from "../../assets/svg/svg13.svg";
import svg29 from "../../assets/svg/svg29.svg";
import svg49 from "../../assets/svg/svg49.svg";
import BreadCrumb from "../../layout/BreadCrumb";
import CardLoading from "../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchCounties, fetchData } from "../../features/fetch/fetchSlice";
import { setActiveObj } from "../../features/obj/objSlice";
import { formatText } from "../../utils";
import useModalToggle from "../../custom_hooks/useModalToggle";
import CountyGovtAddModal from "./CountyGovtAddModal";
import moment from "moment";
import ConfirmModal from "../../components/ConfirmModal";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";

function CountyGovtTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/cidu/get";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/cidu/delete",
        usrId: prodd?.usrId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchCountyGovtData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const [openDelete1, setOpenDelete1] = useState(false);
  const handleOpenDelete1 = () => {
    setOpenDelete1(true);
  };
  const handleCloseDelete1 = () => {
    setOpenDelete1(false);
  };

  const handleDelete1 = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/cidu/delete",
        usrId: prodd?.usrId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchCountyGovtData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        usrCountyName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await handleOpen();
  };

  const handleAdd = async () => {
    await setProdd("");
    await handleOpen();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div
          onClick={
            prodd?.usrStatus == "DELETED" ? handleOpenDelete1 : handleOpenDelete
          }
        >
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg49} alt="svg49" />{" "}
            <span className="whitespace-nowrap">
              {prodd?.usrStatus == "DELETED" ? "Enable" : "Disable"}
            </span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "CIDU",
      dataIndex: "usrCountyName",
      sorter: (a, b) => a.usrCountyName.localeCompare(b.usrCountyName),
    },
    {
      title: "Created Date",
      dataIndex: "usrCreatedDate",
      render: (text) =>
        text ? moment(text).format("DD-MM-YYYY HH:mm:ss") : "--",
      sorter: (a, b) =>
        moment(a.usrCreatedDate).valueOf() - moment(b.usrCreatedDate).valueOf(),
    },
    {
      title: "Projects",
      dataIndex: "usrProjects",
      sorter: (a, b) => a.usrProjects.localeCompare - b.usrProjects,
    },
    {
      title: "Status",
      dataIndex: "usrStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PENDING_APPROVAL: "#3250FF",
          DELETED: "#F44336",
          INACTIVE: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchCountyGovtData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchCountyGovtData();
    dispatch(fetchCounties());
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "County CIDU" }]} />
      <div className="flex flex-col w-full  flex-1  white_card mt-[1.25rem]">
        <div className="flex items-center justify-between  gap-y-4">
          <div className="form-add-h">County Irrigation Department Units</div>
        </div>

        <div className="flex lg:flex-row flex-col gap-y-2 items-center mt-[1.75rem] justify-between">
          <div className="lg:w-[29.1875rem] w-full">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
          <div className="w-[150px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />
              <span className="">Add CIDUs</span>
            </button>
          </div>
        </div>

        <div className="max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.75rem] w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.usrId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchCountyGovtData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <CountyGovtAddModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchCountyGovtData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Disable"
      />

      <ConfirmModal
        open={openDelete1}
        handleCancel={handleCloseDelete1}
        handleSubmit={handleDelete1}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="info"
        btnTitle="Enable"
      />
    </div>
  );
}

export default CountyGovtTable;
